// This list of allowed mime types also exists in the back end at: app/models/media_file.rb
// If you update here, then update there, and vice versa

export const UPLOAD_IMAGE_MIME_TYPES = ['image/png', 'image/jpeg', 'image/svg+xml', 'image/webp']
export const UPLOAD_IMAGE_MIME_TYPES_NO_SVG = ['image/png', 'image/jpeg', 'image/webp']
export const UPLOAD_VIDEO_MIME_TYPES = ['video/mp4', 'video/mpeg', 'video/webm', 'video/quicktime']
export const UPLOAD_AUDIO_MIME_TYPES = ['audio/mpeg', 'audio/ogg', 'audio/wav', 'audio/webm']
export const UPLOAD_DOCUMENT_MIME_TYPES = ['application/pdf', '.txt', '.docx', '.doc']

export const UPLOAD_IMAGE_AND_VIDEO_MIME_TYPES = [...UPLOAD_IMAGE_MIME_TYPES, ...UPLOAD_VIDEO_MIME_TYPES]
export const UPLOAD_MIME_TYPES = [...UPLOAD_IMAGE_MIME_TYPES, ...UPLOAD_AUDIO_MIME_TYPES, ...UPLOAD_VIDEO_MIME_TYPES]

export const ACCEPTED_IMAGE_MIME_TYPES = UPLOAD_IMAGE_MIME_TYPES.join(',')
export const ACCEPTED_IMAGE_MIME_TYPES_NO_SVG = UPLOAD_IMAGE_MIME_TYPES_NO_SVG.join(',')
export const ACCEPTED_VIDEO_MIME_TYPES = UPLOAD_VIDEO_MIME_TYPES.join(',')
export const ACCEPTED_AUDIO_MIME_TYPES = UPLOAD_AUDIO_MIME_TYPES.join(',')
export const ACCEPTED_IMAGE_AND_VIDEO_MIME_TYPES = UPLOAD_IMAGE_AND_VIDEO_MIME_TYPES.join(',')
export const ACCEPTED_MIME_TYPES = UPLOAD_MIME_TYPES.join(',')
export const ACCEPTED_DOCUMENT_MIME_TYPES = UPLOAD_DOCUMENT_MIME_TYPES.join(',')
